import React, { useState } from "react";
import "./CheckBox.scss";

const CheckBox = (props) => {
    let { labelTitle, id, checked = false, onCheckedChange } = props

    const onChecked = (event) => {
        onCheckedChange?.(event, event.target.checked)
    }

    return (
        <div className="checkboxMain">
            <input
                type="checkbox"
                id={id}
                className="checkbox"
                checked={checked}
                onChange={onChecked}
            />
            <label className="pointerC" id="checkLabel" htmlFor={id}>{labelTitle}</label>
        </div>
    )
}

CheckBox.defaultProps = {
    id: 1,
    checked: false,
    labelTitle: 'Title',
}

export default CheckBox;